import script from "./NewsSinglePublic.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsSinglePublic.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/clubstyle.css?vue&type=style&index=0&lang=css&external"
import "./NewsSinglePublic.vue?vue&type=style&index=1&id=0a8eb0e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a8eb0e0"]])

export default __exports__